/* @flow */

import { useDispatch } from 'react-redux';


const useActionCreator = (actionCreator: () => ThunkAction) => {
  const dispatch = useDispatch();

  return (...args: any) => dispatch(actionCreator(...args));
};

export default useActionCreator;
